String.format = function () {
	// The string containing the format items (e.g. "{0}")
	// will and always has to be the first argument.
	var theString = arguments[0];

	// start with the second argument (i = 1)
	for (var i = 1; i < arguments.length; i++) {
		// "gm" = RegEx options for Global search (more than one instance)
		// and for Multiline search
		var regEx = new RegExp('\\{' + (i - 1) + '\\}', 'gm');
		theString = theString.replace(regEx, arguments[i]);
	}

	return theString;
};

// Utility function for parsing query params
// http://www.joezimjs.com/javascript/3-ways-to-parse-a-query-string-in-a-url/
var parseQueryString = function (url) {
	var params = {},
		queries, temp, i, l;

	var urlParts = url.split('?');
	if (urlParts.length > 1) {
		var queryString = urlParts[1];

		// Split into key/value pairs
		queries = queryString.split('&');

		// Convert the array of strings into an object
		for (i = 0, l = queries.length; i < l; i++) {
			temp = queries[i].split('=');
			params[temp[0]] = temp[1];
		}
	}
	return params;
};

// XXX if there is already a urlencoded query param, it will get double encoded by jQuery.param()
var addQueryParam = function (url, factoryNdxs, qryParams, singleParamOnly) {
	singleParamOnly = !!singleParamOnly;
	var params = parseQueryString(url);
	var baseUrl = url.split('?')[0];
	if (!!factoryNdxs) {
		baseUrl = String.format(baseUrl, factoryNdxs);
	}

	for (var paramKey in qryParams) {
		if (typeof qryParams[paramKey] === 'undefined') {
			continue;
		}
		if (singleParamOnly && qryParams[paramKey].length <= 1) {
			params[paramKey] = qryParams[paramKey][0];
		} else if (singleParamOnly && qryParams[paramKey].length > 1) {
			params[paramKey] = undefined;
		} else if (!singleParamOnly && qryParams[paramKey].length !== 0) {
			for (var i = 0; i < qryParams[paramKey].length; i++) {
				// pre-encode to handle commas in strings
				if (typeof qryParams[paramKey][i] === 'string') {
					qryParams[paramKey][i] = qryParams[paramKey][i].replace(/,/g, '@@##');
				}
			}
			params[paramKey] = qryParams[paramKey].toString(); // slams array into comma delim str
		}
	}

	if (!!params && jQuery.param(params)) {
		baseUrl = baseUrl + '?' + jQuery.param(params);
	}
	return baseUrl;
};

function removeQueryParams(url, paramsToKeep) {
	var params = parseQueryString(url);
	var baseUrl = url.split('?')[0];
	var qryParams = {};
	for (var i = 0; i < paramsToKeep.length; i++) {
		if (params[paramsToKeep[i]]) {
			qryParams[paramsToKeep[i]] = params[paramsToKeep[i]];
		}
	}
	if (!!qryParams && jQuery.param(qryParams)) baseUrl = baseUrl + '?' + jQuery.param(qryParams);
	return baseUrl;
}

var getQueryParam = function (qryParams, singleParamOnly) {
	singleParamOnly = !!singleParamOnly;
	var params = {};
	var returnQueryParams = null;
	for (var paramKey in qryParams) {
		if (typeof qryParams[paramKey] === 'undefined') {
			continue;
		}
		if (singleParamOnly && qryParams[paramKey].length <= 1) {
			params[paramKey] = encodeURIComponent(qryParams[paramKey][0]);
		} else if (singleParamOnly && qryParams[paramKey].length > 1) {
			params[paramKey] = undefined;
		} else if (!singleParamOnly && qryParams[paramKey].length !== 0) {
			for (var i = 0; i < qryParams[paramKey].length; i++) {
				// pre-encode to handle commas in strings
				if (typeof qryParams[paramKey][i] === 'string') {
					if (qryParams[paramKey][i].indexOf(',') > -1) {
						qryParams[paramKey][i] = encodeURIComponent(qryParams[paramKey][i].replace(/,/g, '@@##'));
					}

				}
			}
			params[paramKey] = qryParams[paramKey].toString(); // slams array into comma delim str
		}
	}

	if (!!params && jQuery.param(params)) {
		returnQueryParams = jQuery.param(params);
	}
	return returnQueryParams;
};

/**
 * Add a URL parameter (or changing it if it already exists)
 * @param {search} string  this is the string representing the current query params
 * @param {key}    string  the key to set
 * @param {val}    string  value 
 * Credit: http://stackoverflow.com/questions/486896/adding-a-parameter-to-the-url-with-javascript
 */
function appendQueryParam(search, key, val) {
	var newParam = key + '=' + val,
		params = '?' + newParam;

	// If the "search" string exists, then build params from it
	if (search) {
		// Try to replace an existing instance
		params = search.replace(new RegExp('([\?&])' + key + '=[^&]*'), '$1' + newParam);

		// If nothing was replaced, then add the new param to the end
		if (params === search) {
			params += '&' + newParam;
		}
	}

	return params;
}

function updateEventBind(scopeElement, events) {
	if (scopeElement.model.eventBind === undefined) {
		for (var i = 0; i < events.length; i++) {
			scopeElement.$on(events[i], function (event, name, model) {
				scopeElement.$parent.$broadcast('widgetReload');
			});
		}
	}
	scopeElement.model.eventBind = true;
}

function makeSVG(tag, attrs) {
	var el = document.createElementNS('http://www.w3.org/2000/svg', tag);
	for (var k in attrs)
		el.setAttribute(k, attrs[k]);
	return el;
}

var directiveFn2 = function ($compile, $window, $filter, $rootScope, hostUrl, getJsonData, eventName, xAxisField,
	yAxisFieldName1, yAxisFieldName2, yAxisFieldLabel, toolTipLabel1, toolTipLabel2, fmtService, primaryColor, yOneColor, yTwoColor) {

	return {
		restrict: 'A',
		scope: {},
		link: function (scope, elem, attrs) {

			var chart;
			var generateListener;
			//get the window width to help with responsiveness
			var w = angular.element($window);
			var width = Math.max(w.width(), window.innerWidth);
			scope.height = window.innerHeight;
			scope.paddingTop = 4;
			elem[0].id = elem[0].id + scope.$id;
			var scopeAccessor = scope.$parent.$parent;
			var widgetHeight = 250;
			var numAxisTicks = 3;
			var slideshow = false;
			if (jQuery(elem[0]).parents('.slideshowWidget').length) {
				widgetHeight = scope.height - 130;
				numAxisTicks = 5;
				scope.paddingLeft = 78;
				scope.paddingRight = 78;
				scope.paddingTop = 10;
				scope.paddingBottom = 14;
				slideshow = true;
			}

			if (width > 992) {
				scope.paddingRt = slideshow ? 78 : 59;
				scope.paddingLt = slideshow ? 78 : 59;
				scope.rectOneX = -30;
				scope.rectTwoX = 20;
				scope.rectSide = slideshow ? 14 : 10;
				scope.fontSize = slideshow ? '14px' : '10px';
			} else if (width >= 768) {
				scope.paddingRt = slideshow ? 78 : 48;
				scope.paddingLt = slideshow ? 78 : 48;
				scope.rectOneX = -27.5;
				scope.rectTwoX = 17.5;
				scope.rectSide = slideshow ? 14 : 8;
				scope.fontSize = slideshow ? '14px' : '8px';
			} else {
				scope.paddingRt = slideshow ? 78 : 36;
				scope.paddingLt = slideshow ? 78 : 36;
				scope.rectOneX = -23;
				scope.rectTwoX = 16;
				scope.rectSide = slideshow ? 14 : 6;
				scope.fontSize = slideshow ? '14px' : '6px';
			}

			setWidgetPaddings();

			scope.getWindowDimensions2 = function () {
				return {
					'w': Math.max(w.width(), window.innerWidth),
					'h': window.innerHeight
				};
			};

			scope.$watch(scope.getWindowDimensions2, function (newValue, oldValue) {
				scope.windowWidth2 = newValue.w;
				scope.height = newValue.h;
				var currentPaddingLeft = scope.paddingLt;
				var fontSize = '10px';
				if (scope.windowWidth2 >= 992) {
					scope.paddingRt = slideshow ? 78 : 59;
					scope.paddingLt = slideshow ? 78 : 59;
					scope.rectOneX = -30;
					scope.rectTwoX = 20;
					scope.rectSide = slideshow ? 14 : 10;
					scope.fontSize = slideshow ? '14px' : '10px';
				} else if (scope.windowWidth2 >= 768) {
					scope.paddingRt = slideshow ? 78 : 48;
					scope.paddingLt = slideshow ? 78 : 48;
					scope.rectOneX = -27.5;
					scope.rectTwoX = 17.5;
					scope.rectSide = slideshow ? 14 : 8;
					scope.fontSize = slideshow ? '14px' : '8px';
				} else {
					scope.paddingRt = slideshow ? 78 : 36;
					scope.paddingLt = slideshow ? 78 : 36;
					scope.rectOneX = -23;
					scope.rectTwoX = 16;
					scope.rectSide = slideshow ? 14 : 6;
					scope.fontSize = slideshow ? '14px' : '6px';
				}
				if (slideshow) {
					widgetHeight = scope.height - 130;
				}
				setWidgetPaddings();
				if (currentPaddingLeft !== scope.paddingLt || slideshow) {
					generateChart();
					paintLegend();
					paintRect(yOneColor, yTwoColor);
				}
			}, true);

			function setWidgetPaddings() {
				if (!globalConfig.browser.locale.startsWith('en')) {
					scope.paddingLt = scope.paddingLt + 10;
					scope.paddingRt = scope.paddingRt + 20;
				}
			}
			w.bind('resize', function () {
				scope.$apply();
			});

			function paintRect(color1, color2) {
				var parentElem = elem[0];
				var axisYParent = jQuery(parentElem).find('.c3-axis-y')[0];
				var axisY2Parent = jQuery(parentElem).find('.c3-axis-y2')[0];
				var axisYTopTick;
				var axisY2TopTick;
				var childTicks;
				if (axisYParent) {
					childTicks = jQuery(axisYParent).find('.tick');
					if (childTicks && childTicks.length === 3) {
						axisYTopTick = childTicks[2];
					} else if (childTicks && childTicks.length === 5) {
						axisYTopTick = childTicks[4];
					}
				}
				if (axisY2Parent) {
					childTicks = jQuery(axisY2Parent).find('.tick');
					if (childTicks && childTicks.length === 3) {
						axisY2TopTick = childTicks[2];
					} else if (childTicks && childTicks.length === 5) {
						axisY2TopTick = childTicks[4];
					}
				}
				if (axisYTopTick && axisY2TopTick) {
					var squareY = makeSVG('rect', {
						x: scope.rectOneX,
						y: 10,
						width: scope.rectSide,
						height: scope.rectSide,
						fill: color1
					});
					var squareY2 = makeSVG('rect', {
						x: scope.rectTwoX,
						y: 10,
						width: scope.rectSide,
						height: scope.rectSide,
						fill: color2
					});
					jQuery(axisYTopTick).prepend(squareY);
					jQuery(axisY2TopTick).prepend(squareY2);
				}
			}

			function tooltipFormat(d, defaultTitleFormat, defaultValueFormat, color) {
				var $$ = this,
					config = $$.config,
					CLASS = $$.CLASS,
					titleFormat = config.tooltip_format_title || defaultTitleFormat,
					nameFormat = config.tooltip_format_name || function (name) {
						return name;
					},
					valueFormat = config.tooltip_format_value || defaultValueFormat,
					text, i, title, value, name, bgcolor;
				for (i = 0; i < d.length; i++) {
					if (!(d[i] && (d[i].value || d[i].value === 0))) {
						continue;
					}

					if (!text) {
						title = titleFormat ? titleFormat(d[i].x) : d[i].x;
						text = "<table class='" + CLASS.tooltip + "'>" + (title || title === 0 ? "<tr><th colspan='2'>" + title + '</th></tr>' : '');
					}

					value = valueFormat(d[i].value, d[i].ratio, d[i].id, d[i].index);
					if (value !== undefined) {
						if (d[i].id === yAxisFieldName1) {
							name = toolTipLabel1;
						} else {
							name = toolTipLabel2;
						}
						if (d[i].id == yAxisFieldName1) {
							if (d[i].value > 0) {
								bgcolor = '#f42f2f';
							} else {
								bgcolor = primaryColor;
							}
						} else {
							bgcolor = yTwoColor;
						}
						text += "<tr class='" + CLASS.tooltipName + '-' + d[i].id + "'>";
						text += "<td class='name'><span style='background-color:" + bgcolor + "'></span>" + name + '</td>';
						text += "<td class='value'>" + value + '</td>';
						text += '</tr>';
					}
				}
				return text + '</table>';
			}

			function paintLegend() {
				var width = elem[0].offsetWidth - 10;
				if (slideshow && width <= 0) {
					width = jQuery(window).width() - 54;
				}
				//remove old one if there
				var oldLegend = d3.select('#' + elem[0].id).select('svg').select('.legend');
				if (oldLegend) {
					oldLegend.remove();
				}
				var offset = 0;
				if (scope.rectSide == 8) {
					offset = 1;
				} else if (scope.rectSide == 6) {
					offset = 2;
				} else if (slideshow) {
					offset = -2.5;
				}
				var newLegend = d3.select('#' + elem[0].id).select('svg').append('g', '.chart').attr('class', 'legend').attr('transform', 'translate(' + 0 + ', ' + widgetHeight + ')');
				var firstRect = width / 10 * (toolTipLabel1.length > toolTipLabel2.length && toolTipLabel1.length > 15 ? 2 : 4);
				var secondRect = width / 10 * 6;
				newLegend.append('rect')
					.attr('x', firstRect)
					.attr('y', -10 + offset)
					.attr('width', scope.rectSide)
					.attr('height', scope.rectSide)
					.attr('fill', primaryColor);
				newLegend.append('text')
					.attr('class', 'text-box')
					.attr('x', firstRect + (scope.rectSide + scope.rectSide / 2))
					.attr('y', -2.5)
					.attr('fill', 'black')
					.attr('font-size', scope.fontSize)
					.text(function (d, i) {
						return toolTipLabel1;
					});
				newLegend.append('rect')
					.attr('x', secondRect)
					.attr('y', -10 + offset)
					.attr('width', scope.rectSide)
					.attr('height', scope.rectSide)
					.attr('fill', yTwoColor);
				newLegend.append('text')
				.attr('class', 'text-box')
					.attr('x', secondRect + (scope.rectSide + scope.rectSide / 2))
					.attr('y', -2.5)
					.attr('fill', 'black')
					.attr('font-size', scope.fontSize)
					.text(function (d, i) {
						return toolTipLabel2;
					});
			}

			function getMin(data) {
				var min = d3.min(data, function (d) {
					return d[yAxisFieldName1];
				});
				if (min > 0) {
					return 0;
				}
				return min;
			}
			var generateChart = function () {
				var chartWidth = jQuery('#' + elem[0].id).width() - scope.paddingLt - scope.paddingRt;
				var currency = scopeAccessor.currency;
				if (currency && currency.length >= 3) {
					scope.paddingLt += 20;
					scope.paddingRt += 20;
				}

				var data = scopeAccessor.chartData;
				if (!data) {
					return;
				}

				var barWidth = chartWidth / data.length;
				angular.forEach(data, function (d) {
					d[xAxisField] = new Date(d[xAxisField]);
				});

				var config = {};
				config.bindto = '#' + elem[0].id;
				config.data = {};
				config.data.keys = {
					x: xAxisField,
					value: [yAxisFieldName1, yAxisFieldName2]
				};
				config.data.json = data;
				config.data.type = 'bar';
				config.data.types = {
					cumulative: 'spline'
				};
				config.data.axes = {
					ppv: 'y',
					cumulative: 'y2'
				};
				config.padding = {
					right: scope.paddingRt,
					left: scope.paddingLt,
					bottom: 8,
					top: scope.paddingTop
				};
				config.axis = {};
				config.axis.x = {
					'type': 'timeseries',
					localtime: true,
					tick: {
						format: function (x) {
							return $filter('date')(x, 'MMM-yyyy');
						}
					}
				};
				// Display up to 6 labels on the x axis, don't have room for more.
				// If there are more, just show the first month and the last month.
				if (data.length < 7) {
					config.axis.x.tick.fit = true;
				} else {
					config.axis.x.tick.count = 2;
				}
				config.bar = {
					width: barWidth * 0.6
				};
				config.axis.y = {
					tick: {
						format: function(x) {
							return fmtService.get(x, currency);
						},
						count: numAxisTicks
					},
					min: getMin(data),
					max: d3.max(data, function (d) {
						return d[yAxisFieldName1];
					}),
					padding: {
						bottom: 0
					}
				};
				config.axis.y2 = {
					show: true,
					tick: {
						format: function(x) {
							return fmtService.get(x, currency);
						},
						count: numAxisTicks
					},
					min: d3.min(data, function (d) {
						return d[yAxisFieldName2];
					}),
					max: d3.max(data, function (d) {
						return d[yAxisFieldName2];
					}),
					padding: {
						bottom: 0
					}
				};
				config.point = {
					r: 0.5,
					focus: {
						expand: {
							r: 3.5
						}
					}
				};
				config.size = {};
				config.size.height = widgetHeight;
				config.legend = {};
				config.legend.show = false;
				config.grid = {
					x: {
						show: false
					},
					y: {
						show: true,
						lines: [{
							value: 0
						}]
					}
				};

				config.data.color = function (color, d) {
					if (!d.id) {
						return primaryColor;
					} else if (d.id == yAxisFieldName1) {
						if (d.value > 0) {
							return '#ff0000';
						} else {
							return primaryColor;
						}
					} else {
						return color;
					}
				};

				config.tooltip = {
					contents: tooltipFormat
				};
				chart = c3.generate(config);
			};

			generateListener = scope.$on(eventName, function () {
				generateChart();
				paintLegend();
				paintRect(yOneColor, yTwoColor);
			});

			scope.$on('$destroy', function () {
				if (chart) {
					chart.destroy();
				}
				if (generateListener) {
					generateListener();
				}
			});
		}
	};
};

// Return index of an element in the array that has a property with the specified search value.
// array - array to search
// property - property in each element in the array to use for comparison
// searchValue - the value to match against the element of the array
// Return: -1 if not found; the index of the matched element otherwise
function findInArray(array, property, searchValue) {
	if (!array) return -1;
	for (var i = 0; i < array.length; i++) {
		if (array[i][property] === searchValue) {
			return i;
		}
	}
	return -1;
}

var strip = ( function() {
	var tmp = document.createElement('DIV');
	return function(html) {
		tmp.textContent = html;
		return tmp.innerHTML;
	};
})();

function dateMidpoint(date1, date2) {
	return new Date((date1.getTime() + date2.getTime()) / 2);
}

function getTimeRange(dateList, dateKey) {
	if (dateList && dateList.length > 0) {
		var minDate = dateList[0][dateKey];
		var maxDate = dateList[0][dateKey];
		for (var i = 0; i < dateList.length; i++) {
			if (dateList[i][dateKey] < minDate) {
				minDate = dateList[i][dateKey];
			}
			if (dateList[i].dateLog > maxDate) {
				maxDate = dateList[i][dateKey];
			}
		}
		return maxDate - minDate;
	} else {
		return 0;
	}
}

function syncColHeights() {
	var cols = jQuery('.column');
	var maxHeight = 120;
	for (var i = 0; i < cols.length; i++) {
		jQuery(cols[i]).removeAttr('style');
		if (jQuery(cols[i]).height() > maxHeight) {
			maxHeight = jQuery(cols[i]).height();
		}
	}
	for (var i = 0; i < cols.length; i++) {
		jQuery(cols[i]).height(maxHeight);
	}
}

function decimalPlaces(num) {
	var match = ('' + num).match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
	if (!match) {
		return 0;
	}
	return Math.max(
		0,
		// Number of digits right of decimal point.
		(match[1] ? match[1].length : 0)
		// Adjust for scientific notation.
		-
		(match[2] ? +match[2] : 0));
}

function isMobile() {
	var isMobile = false; //initiate as false
	//device detection
	if (/(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|ipad|iris|kindle|Android|Silk|lge |maemo|midp|mmp|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i.test(navigator.userAgent) || /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(navigator.userAgent.substr(0, 4))) isMobile = true;
	return isMobile;
}

var chartTypes = {
	'MSLine': 'line',
	'MSColumn2D': 'bar',
	'MSColumn3D': 'bar',
	'ScrollLine2D': 'line',
	'ScrollColumn2D': 'bar',
	'MSSpline': 'spline',
	'LogMSLine': 'line',
	'LogMSColumn2D': 'bar',
	'StackedBar': 'bar',
	'SeparateBar': 'bar'
};

function getDisplayFactoryList(factoryNdxs) {
	var returnList = [];
	for (var i = 0; i < factoryNdxs.length; i++) {
		var ndx = factoryNdxs[i];
		var name = globalConfig.user.authFacts[ndx.toString()].name;
		var alias = globalConfig.user.authFacts[ndx.toString()].alias;
		returnList.push({
			'leanDirFactoryNdx': ndx,
			'factoryName': name,
			'factoryAlias': alias
		});
	}
	return returnList;
}

function getTimeOffset(time) {
	var m = moment(time);
	return m.fromNow();
}

function escapeSingleQoute(rawData) {
	return rawData ? rawData.replace(/'/g, "\\\'"): rawData;
}